module.exports = __webpack_public_path__ + "static/tw-portfolio-tab-eb0a55b14b7a1b0c39ff119d6f3091fd.jpg";